// the page component that owns an element (walks up to the closest Vue instance passing `test`)
export function ownerVm(el, test){
  for (var n = el; n; n = n.parentElement){
    var vm = n.__vue__;
    while (vm){
      if (test(vm)) return vm;
      vm = vm.$parent;
    }
  }
  return null;
}
